<template>
  <div class="container">
    <!-- <div class="columns descriptionBox"> -->
    <div class="descriptionBox flex flex-col md:flex-row">
      <!-- <div class="column"> -->
      <img class="m-8" src="../picture/cogi_puro.jpg">
      <!-- </div> -->

      <article class="message is-dark">
        <div class="message-body">
          <p id="name" class="text-5xl">about me</p>
          <br>
          <p id="name" class="text-2xl">Karin Hamano</p>
          <p>
            <v-fa :icon="['fas', 'birthday-cake']" />　1998/05/25</p>
          <p>
            <v-fa :icon="['fas', 'graduation-cap']" />　明治大学先端数理科学科先端メディアサイエンス専攻</p>
          <br>
          <br>
          <p id="name" class="text-2xl">
            <v-fa :icon="['fas', 'heart']" class="text-xl" />　like　
            <v-fa :icon="['fas', 'heart']" class="text-xl" />
          </p>
          <p>いぬ サンリオ こぎみゅん コスメ</p>
          <p>チョコレート ハンバーグ 京都 etc.</p>
          <br>
          <br>
          <p id="name" class="text-2xl">
            <v-fa :icon="['fas', 'pencil-alt']" class="text-xl" />　skills　
            <v-fa :icon="['fas', 'pencil-alt']" class="text-xl" />
          </p>
          <p>Processing / HTML / CSS / PHP / Vue.js / Python</p>
          <br>
          <br>
          <a href="https://twitter.com/onigiri____mgmg">
            <p>
              <v-fa :icon="['fab', 'twitter']" />　@onigiri____mgmg</p>
          </a>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  // import profileDescription from "@/components/profileDescription.vue"

  export default {
    components: {
      // profileDescription
    }
  }
</script>

<style lang="css" scoped>
  .descriptionBox {
    width: 80vw;
    display: flex;
    align-items: center;
    margin: auto;
  }

  img {
    width: 200px;
    height: 200px;
    object-fit: cover;
    overflow: hidden;
  }

  .message {
    width: 50vw;
  }

  .message.is-dark .message-body {
    border-color: #432444;
    color: #432444;
    background-color: #EBE1E1;
  }

  .message a:not(.button):not(.tag):not(.dropdown-item) {
    text-decoration: none;
  }

  #name {
    font-family: 'Sacramento', cursive;
  }
</style>